<template>
    <el-row class="main-box  flex-column flex1">
        <el-col>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 22, offset: 1 }"
                    :lg="{ span: 22, offset: 1 }">
                    <div class="contetnt-info flex-column ">
                        <div class="content-info-titlebox flex-row  f-justify-between">
                            <div class="content-info-titlebox-left flex-row">
                                <span>我的收藏</span>
                            </div>

                            <div v-if="detailShow" @click="backHandle" class="content-info-tab-btn">返回</div>
                        </div>
                        <div class="content-info-line"></div>
                        <template v-if="!detailShow">
                            <div class="content-info-list flex-row flex-wrap ">
                                <template v-if="bookList.length > 0">
                                    <div v-for="(item, index) in bookList" :key="'item' + index" @click="toDetail(index)"
                                        class="content-info-item-box flex-column">
                                        <div class="content-info-item flex-column  f-center">
                                            <img class="content-info-item-img"
                                                :src="item.url ? item.url : require('@/static/logo.png')" alt="">
                                            <div class="content-info-item-badge flex-column f-center ">
                                                <img @click.stop="openDeleteClassDialog(index)"
                                                    src="../static/delete-badge.png" alt="">
                                            </div>
                                        </div>
                                        <span class="content-ingo-item-name">{{ item.courseName }}</span>
                                    </div>
                                </template>

                                <template v-else>
                                    <div class="flex-column flex1 f-align-center">
                                        <img class="no-data" src="../static/saleClass-nodata.png" alt="">
                                        <span>暂无收藏的课程~</span>
                                    </div>
                                </template>

                            </div>
                            <div v-if="bookList.length > 0" class="flex-row f-justify-center ">
                                <div class="page-contorlbox page-contorlbox-position flex-row f-justify-center">
                                    <div class="page-controlbox-btn" @click="prePageBookHadle()"
                                        :class="pageNum == 1 ? 'page-controlbox-btn-disabled' : ''">上一页</div>
                                    <div @click="nextPageBookHadle()" class="page-controlbox-btn"
                                        :class="bookListTotal == bookList.length ? 'page-controlbox-btn-disabled' : ''">下一页
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="content-info-detaillist flex-row flex-wrap ">
                                <template v-if="bookDetailList.length > 0">
                                    <div v-for="(item, index) in bookDetailList" :key="'detail' + index"
                                        class="content-info-detaillist-item flex-row f-align-center f-justify-between">
										
										
										<el-tooltip  effect="dark"  placement="top-end">
											<div slot="content">{{item.phonetic}} <br>{{item.chinese}}</div>
											<span class="content-info-detaillist-item-word">{{item.word}}</span>
										</el-tooltip>
										
										
                                        <div @click="openDeleteDetailClassDialog(index)"
                                            class="content-info-detaillist-item-badge flex-column f-center">
                                            <img src="../static/delete-badge.png" alt="">
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex-column flex1 f-align-center">
                                        <img class="no-data" src="../static/saleClass-nodata.png" alt="">
                                        <span>暂无收藏的单词~</span>
                                    </div>
                                </template>
                            </div>
                            <div v-if="bookDetailList.length > 0" class="flex-row f-justify-center ">
                                <div class="page-contorlbox page-contorlbox-position flex-row f-justify-center">
                                    <div @click="prePageBookDetailHadle()" class="page-controlbox-btn"
                                        :class="pageNum == 1 ? 'page-controlbox-btn-disabled' : ''">上一页</div>
                                    <div @click="nextPageBookDetailHadle()" class="page-controlbox-btn"
                                        :class="bookDetailListTotal == bookDetailList.length ? 'page-controlbox-btn-disabled' : ''">
                                        下一页</div>
                                </div>
                            </div>
                        </template>

                    </div>

                </el-col>
            </el-row>

        </el-col>


        <el-dialog title="" :center="true" :visible.sync="dialogremoveClass" :show-close="false"
            @closed="dialogremoveClassClosed">

            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogremoveClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column f-center">
                        <span class="start-popup-content-text1">是否删除收藏的课程？</span>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end">
                            <div @click="dialogremoveClass = false">取消</div>
                            <div @click="deleteClassHandle">确认</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>


        <el-dialog title="" :center="true" :visible.sync="dialogremoveDetailClass" :show-close="false"
            @closed="dialogremoveDetailClassClosed">

            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogremoveDetailClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column f-center">
                        <span class="start-popup-content-text1">是否删除收藏的单词？</span>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end">
                            <div @click="dialogremoveDetailClass = false">取消</div>
                            <div @click="deleteDetailClassHandle">确认</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>




    </el-row>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import numerSplit from '../components/numerSplit.vue';
import { Message } from 'element-ui';
import moment from "moment";

export default {

    data() {
        return {
            detailShow: false,

            pageNum: 1,
            pageSize: 12,
            bookList: [],
            bookListIndex: 0,
            bookListTotal: 0,

            bookDetailList: [],
            bookDetailListIndex: 0,
            bookDetailListTotal: 0,
            bookDetailPageNum: 1,
            bookDetailPageSize: 20,

            dialogremoveClass: false,
            dialogremoveDetailClass: false,
        }
    },
    created() {
        this.getCollection();
    },
    computed: {
        ...mapState([
            'userInfos',
        ]),
        ...mapGetters(["getUserToken"]),
        getZhanweinum() {
            let listLenth = 10;
            return Math.ceil(listLenth / 6) * 6 - listLenth;
        },
        getDetailZhanweinum() {
            let listLenth = 6;
            return Math.ceil(listLenth / 4) * 4 - listLenth;
        }
    },
    methods: {
        backHandle() {
            this.detailShow = false;
            this.bookDetailList = [];
            this.bookDetailListIndex = 0;
            this.bookDetailListTotal = 0;
            this.bookDetailPageNum = 1;
            this.bookDetailPageSize = 12;

            this.getCollection();

        },
        async toDetail(index) {

            this.bookListIndex = index;

            if (this.userInfos.role == 0) {
                let res = await this.$api.get("web/student/collect/detail/list", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        pageNum: this.bookDetailPageNum,
                        pageSize: this.bookDetailPageSize,
                        courseId: this.bookList[this.bookListIndex].courseId
                    }
                })

                if (res.code == 200) {
                    this.detailShow = true;
                    this.bookDetailList = res.rows;
                    this.bookDetailListTotal = res.total;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }

            }

        },
        async getCollection() {
            if (this.userInfos.role == 0) {
                let res = await this.$api.get("web/student/collect/list", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }
                })

                if (res.code == 200) {
                    this.bookList = res.rows;
                    this.bookListTotal = res.total;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }

            }
        },
        prePageBookHadle() {
            if (this.pageNum == 1) {
                return;
            }

            this.pageNum--;
            this.getCollection();

        },
        nextPageBookHadle() {
            if (this.bookListTotal == this.bookList.length) {
                return;
            }
            this.pageNum++;
            this.getCollection();

        },
        prePageBookDetailHadle() {
            if (this.bookDetailPageNum == 1) {
                return;
            }

            this.bookDetailPageNum--;
            this.toDetail(this.bookListIndex);

        },
        nextPageBookDetailHadle() {
            if (this.bookDetailListTotal == this.bookDetailList.length) {
                return;
            }
            this.bookDetailPageNum++;
            this.toDetail(this.bookListIndex);

        },
        openDeleteClassDialog(index) {
            this.bookListIndex = index;
            this.dialogremoveClass = true;
        },
        async deleteClassHandle() {
            if (this.userInfos.role == 0) {


                let res = await this.$api.post("web/student/collect/webRemoveCourseALLCollect", {
                    courseId: this.bookList[this.bookListIndex].courseId,
                    recordId: "0"
                }, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    }
                })


                if (res.code == 200) {
                    Message({
                        type: "success",
                        message: "删除成功"
                    })
                    this.dialogremoveClass = false;
                    this.bookList.splice(this.bookListIndex, 1);
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }



            }



        },
        dialogremoveClassClosed() {
            this.bookListIndex = 0;
        },
        openDeleteDetailClassDialog(index) {
            this.bookDetailListIndex = index;
            this.dialogremoveDetailClass = true;
        },
        async deleteDetailClassHandle() {
            if (this.userInfos.role == 0) {


                let res = await this.$api.post("web/student/collect/remove", {
                    courseId: this.bookDetailList[this.bookDetailListIndex].courseId,
                    recordId: this.bookDetailList[this.bookDetailListIndex].recordId
                }, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    }
                })
                if (res.code == 200) {
                    Message({
                        type: "success",
                        message: "删除成功"
                    })

                    this.bookDetailList.splice(this.bookDetailListIndex, 1);
                    this.dialogremoveDetailClass = false;

                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }


            }



        },
        dialogremoveDetailClassClosed() {
            this.bookDetailListIndex = 0;
        }




    }

}
</script>

<style lang="scss" scoped>
.main-box {
    background: #E5F3F1;

    position: relative;

    .content-box-col {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .contetnt-info {
        padding: 18px 35px 35px 23px;
        width: 91.4777%;
        min-height: 828px;
        border-radius: 20px;
        box-sizing: border-box;
        margin-top: 40px;
        background: #FFFFFF;

        .content-info-titlebox {
            height: 46px;
            .content-info-titlebox-left {
                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                span {
                    font-family: Source Han Sans CN;
                    font-size: 26px;
                    font-weight: bold;
                    line-height: normal;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 333333 */
                    color: #333333;
                }
            }


            .content-info-tab-btn {
                width: 134px;
                height: 46px;
                border-radius: 100px;
                /* 灰 */
                background: #ACBEB0;

                font-family: 思源黑体;
                font-size: 18px;
                font-weight: bold;
                line-height: 46px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;

                &:hover{
                    cursor: pointer;
                }

            }

        }

    }

    .content-info-tab {
        margin-top: 23px;
        margin-left: 36px;
        height: 46px;

        font-family: 思源黑体;
        font-size: 26px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 全部 */
        color: #333;

        .content-info-tab-item {
            margin-right: 66px;
            position: relative;

            &:hover {
                cursor: pointer;
            }
        }

        .content-info-tab-item-actived {
            color: #0AA26B;

            &::after {
                display: inline-block;
                content: "";
                position: absolute;
                width: 90px;
                height: 4px;

                /* 绿 */
                background: #0AA26B;
                bottom: -14px;
                left: -45px;
                margin-left: 50%;
            }
        }
    }

    .content-info-tab-tips {
        margin-right: 20px;
        font-family: 思源黑体;
        font-size: 18px;
        font-weight: normal;
        line-height: normal;
        text-align: center;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;
    }

    .content-info-tab-btn {
        width: 134px;
        height: 46px;
        border-radius: 100px;
        /* 灰 */
        background: #ACBEB0;

        font-family: 思源黑体;
        font-size: 18px;
        font-weight: bold;
        line-height: 46px;
        text-align: center;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 纯白 */
        color: #FFFFFF;
    }

    .content-info-line {
        margin-top: 17px;
        width: 100%;
        height: 0px;
        opacity: 1;

        border: 1px solid #DCDFDD;
    }

    .content-info-list {
        margin-top: 22px;

        .zhanwei_box {
            margin-bottom: 32px;
            width: 238px;
            height: 238px;
            background: #fff;
        }

        .content-info-item-box {
            margin-bottom: 32px;
            margin-right: 25px;

            .content-ingo-item-name {
                margin-top: 15px;
                font-family: 思源黑体;
                font-size: 18px;
                font-weight: normal;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }
        }

        .content-info-item {

            width: 238px;
            height: 238px;
            border-radius: 20px;
            background: #E5F7F1;

            box-sizing: border-box;

            position: relative;

            .content-info-item-img {
                border-radius: 19px;
                width: 238px;
                height: 238px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-info-item-badge {
                top: 0px;
                width: 45px;
                height: 45px;
                border-radius: 0px 20px 0px 20px;
                opacity: 1;

                /* 绿 */
                background: #0AA26B;
                position: absolute;
                top: 0;
                right: 0;

                img {
                    width: 24px;
                    height: 24px;
                }

                &:hover {
                    cursor: pointer;
                }

            }

        }
    }

}

.content-info-detaillist {
    margin-top: 30px;

    .detail_zhanwei_box {
        width: 366px;
        height: 80px;
        border-radius: 100px;
        background: #fff;
    }

    .content-info-detaillist-item {
        margin-right: 29px;
        min-width: 366px;
        height: 80px;
        border-radius: 100px;
        background: #E5F7F1;
        margin-bottom: 30px;
        box-sizing: border-box;
        border: 1px solid rgba(10, 162, 107, 0.2);
        box-sizing: border-box;
        padding: 0 14px 0 30px;

        .content-info-detaillist-item-word {
            font-family: Oswald;
            font-size: 45px;
            font-weight: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 绿 */
            color: #0AA26B;
        }

     .content-box-item-text{
                width: 100%;
                box-sizing: border-box;
                padding: 0 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break:break-all;
            }
        .content-info-detaillist-item-badge {
            width: 54.18px;
            height: 53px;
            opacity: 1;
            border-radius: 50px;

            /* 绿 */
            background: #0AA26B;

            &:hover {
                cursor: pointer;
            }

            img {
                width: 24.54px;
                height: 24px;
            }
        }

    }
}

.page-contorlbox {
    .page-controlbox-btn {
        text-align: center;
        line-height: 28px;
        margin: 0 10px;
        width: 88px;
        height: 30px;
        border-radius: 100px;
        opacity: 1;

        box-sizing: border-box;
        /* 灰 */
        border: 1px solid #ACBEB0;
        font-family: 思源黑体;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;
    }

    .page-controlbox-btn-disabled {
        background: #757d80;
        color: #cacaca;

        &:hover {
            cursor: no-drop;
        }
    }



}

.page-contorlbox-position {
    position: absolute;
    bottom: 35px;

}


.appraise-popup-title {
    width: 100%;
    height: 86px;
    border-radius: 20px 20px 0 0;
    background: #0AA26B;
    box-sizing: border-box;
    padding: 0 35px;

    .appraise-popup-title-name {
        font-family: 思源黑体;
        font-size: 26px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 纯白 */
        color: #FFFFFF;
    }

    img {
        width: 56px;
        height: 56px;
    }
}

.start-popup-content {
    background: #fff;
    border-radius: 0 0 20px 20px;
    box-sizing: border-box;
    padding: 0 52px;

    .start-popup-content-text1 {

        margin-top: 89px;
        margin-bottom: 89px;
        font-family: 思源黑体;
        font-size: 22px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 333333 */
        color: #333333;
    }

    .start-popup-content-timebox {
        margin-top: 30px;
        margin-left: 173.5px;

        span {
            margin-right: 30px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        div {
            width: 195px;
            height: 64px;
            border-radius: 100px;
            opacity: 1;

            background: #E5F7F1;

            box-sizing: border-box;
            border: 1px solid rgba(10, 162, 107, 0.2);
        }

    }

    .start-popup-content-tipsbox {
        margin-top: 89px;
        margin-bottom: 75px;
        font-family: 思源黑体;
        font-size: 22px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 确认开始学员 */
        color: #333333
    }

    .start-popup-content-line {
        margin-top: 30px;
        width: 100%;
        height: 0px;
        opacity: 1;

        border: 1px solid rgba(10, 162, 107, 0.2);
    }

    .start-popup-content-btnsbox {
        margin-top: 31px;
        margin-bottom: 30px;

        div {
            &:first-child {
                margin-right: 20px;
                width: 230px;
                height: 64px;
                border-radius: 100px;
                /* 灰 */
                background: #ACBEB0;
                font-family: 思源黑体;
                font-size: 28px;
                font-weight: bold;
                line-height: 64px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;
            }

            &:last-child {

                width: 230px;
                height: 64px;
                border-radius: 100px;
                /* 绿 */
                background: #0AA26B;

                font-family: 思源黑体;
                font-size: 28px;
                font-weight: bold;
                line-height: 64px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 纯白 */
                color: #FFFFFF;
            }
        }
    }

}


.no-data {
    margin-top: 110px;
    width: 338px;
    height: 298px;
}



/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>